import { useState, useDebugValue } from 'react';
import moment from 'moment';
import _ from 'lodash';

const stringMatch = (str, find) => {
  const strRegExPattern = `\\b${find}\\b`;
  return str.match(new RegExp(strRegExPattern, 'g'));
};

const dynamicObjectSort = property => {
  let sortOrder = 1;
  let propObject = property;
  if (property[0] === '-') {
    sortOrder = -1;
    propObject = property.substr(1);
  }

  return (a, b) => {
    if (sortOrder === -1) {
      return b[propObject].localeCompare(a[propObject]);
    }
    return a[propObject].localeCompare(b[propObject]);
  };
};

const objectSearch = (item, search) =>
  item.filter(el => el.name.toLowerCase().indexOf(search.toLowerCase()) > -1);

const convertBillerListToAccordion = list => {
  const objectBuilder = {};
  for (let i = 0; i < list.length; i += 1) {
    const item = list[i];
    const accordionObject = {
      id: item.id,
      name: item.name,
      icon: item.icon,
      status: {
        pground_status: _.get(item, 'status.pground_status'),
        skyw_status: _.get(item, 'status.skyw_status'),
      },
    };
    const firstChar = item.name.charAt(0).toUpperCase();
    const hasObjcetProperty = Object.prototype.hasOwnProperty.call(
      objectBuilder,
      firstChar,
    );
    if (hasObjcetProperty) {
      objectBuilder[firstChar].push(accordionObject);
    } else {
      objectBuilder[firstChar] = [];
      objectBuilder[firstChar].push(accordionObject);
    }
  }
  return objectBuilder;
};

const formatDateDMY = string => moment(string).format('DD MMM YYYY');

const escapeRegExp = string => string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const replaceStarToCircle = text =>
  text.replace(new RegExp(escapeRegExp('*'), 'g'), '•');

const formatRupiah = value => {
  let rupiah = '';
  const angkarev = value
    .toString()
    .split('')
    .reverse()
    .join('');
  for (let i = 0; i < angkarev.length; i += 1)
    if (i % 3 === 0) rupiah += `${angkarev.substr(i, 3)}.`;
  return `Rp${rupiah
    .split('', rupiah.length - 1)
    .reverse()
    .join('')}`;
};

export const formatAccount = inputvalue => {
  const value = inputvalue;
  const v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
  const matches = v.match(/\d{4,18}/g);
  const match = (matches && matches[0]) || '';
  const parts = [];

  for (let i = 0, len = match.length; i < len; i += 4) {
    parts.push(match.substring(i, i + 4));
  }

  if (parts.length) {
    return parts.join(' ');
  }
  return value;
};

const formatNumber = inputvalue => {
  const value = inputvalue;
  const v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
  const matches = v.match(/\d{4,99}/g);
  const match = (matches && matches[0]) || '';
  const parts = [];

  for (let i = 0, len = match.length; i < len; i += 4) {
    parts.push(match.substring(i, i + 4));
  }

  if (parts.length) {
    return parts.join(' ');
  }
  return value;
};

const createUUID = () => {
  let dt = new Date().getTime();
  const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (dt + Math.random() * 16) % 16 || 0;
    dt = Math.floor(dt / 16);
    return (c === 'x' ? r : (r && 0x3) || 0x8).toString(16);
  });
  return uuid;
};

const getParamURL = param => {
  const rawUrl = window.location.search;

  const objectURL = _.chain(rawUrl)
    .replace('?', '')
    .split('&')
    .map(_.partial(_.split, _, '=', 2))
    .fromPairs()
    .value();

  const getParam = objectURL[param] || '';

  return getParam;
};

const formatStdNumber = num =>
  num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');

const getLang = () => {
  const langCode = window.navigator.language.split('-')[0];
  switch (langCode) {
    case 'en':
      return 'en';
    case 'id':
      return 'id';
    default:
      return 'id';
  }
};

const getUserId = () => {
  const isOnDebug = window.location.hostname === 'localhost';
  if (isOnDebug) return 'DEBUG';
  if (process.env.ENV === 'PRODUCTION') {
    const value = `; ${_.get(document, 'cookie')}`;
    const parts = value.split(`; userId=`);
    if (parts.length === 2)
      return parts
        .pop()
        .split(';')
        .shift();
    return null;
  }

  return process.env.INJECTED_ID_MIXPANEL;
};

export const parseNumber = string =>
  parseInt(
    string
      .toString()
      .split('.')
      .join(''),
    10,
  ) || 0;

export const useStateWithLabel = (initialValue, name) => {
  const [value, setValue] = useState(initialValue);
  useDebugValue(`${name}: ${value}`);
  return [value, setValue];
};

export const decodeHtml = escapedHtml => {
  const unescapedHtml = unescape(escapedHtml);
  const fontFamilyNativeRegex = /font-family: Native Font;/g;

  return unescapedHtml
    .replace(fontFamilyNativeRegex, '')
    .split('px')
    .map((element, index, array) => {
      if (index < array.length - 1) {
        const word = element.split(' ');
        const fontSizeIndex = word.length - 1;

        const fontSize = (parseFloat(word[fontSizeIndex]) / 10).toString();
        word[fontSizeIndex] = `${fontSize}rem`;

        return word.join(' ');
      }
      return element;
    })
    .join('');
};

export default {
  stringMatch,
  dynamicObjectSort,
  objectSearch,
  convertBillerListToAccordion,
  formatDateDMY,
  escapeRegExp,
  replaceStarToCircle,
  formatAccount,
  formatRupiah,
  createUUID,
  getParamURL,
  formatNumber,
  formatStdNumber,
  getLang,
  getUserId,
  parseNumber,
  useStateWithLabel,
  decodeHtml,
};
